import { useState, useEffect } from "react";
import {
    StyleSheet, View, Text
} from "react-native";

import { FONT } from "../../value/staticValues";
import { PLATFORM_URL } from "../../value/Url";
import { requests } from "../../common/RestAPI";

import { CustomTextInput, TextArea } from "../base/CustomInputText";
import { ReactComponent as StatusStableImg} from "../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../img/ico-status-block.svg";

import { ReactComponent as AlertImg } from "../../img/ico-status-alert.svg";
import { ReactComponent as ErrorImg } from "../../img/ico-status-error.svg";
import { ReactComponent as MsgInfoImg } from '../../img/ico-msg-info-2.svg';

import { useTranslation } from "react-i18next";
import { getAuditLogTypeString } from "./AuditLogUtils";
import { AuditLogSystemData } from "./AuditLogData";
import { parseLocaleDatetime } from "common/util";


interface ArgsType {
    auditLogId: string;
    auditLogType: string;
    auditLogStatus: string;
    subject: string;
    subjectVersion: string;
    userId: string;
    username: string;
    sourceIp: string;
    sourceMac: string;
    sourceName: string;
    op: string;
    command: string;
    message: string;
    targetId: string;
    targetName: string;
    targetType: string;
    errorCode: string;
    createDate: string;
}



interface AuditLogDetailProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    showSlideModalCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
    args?: AuditLogSystemData,
};

AuditLogDetail.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}

export default function AuditLogDetail(props:AuditLogDetailProps) {
    const { t } = useTranslation();

    const [stepIndex, setStepIndex] = useState(0);


    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);


    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            if(stepIndex < props.stepCount - 1) {
                if(stepIndex === 0) {

                }
            } else {
                executeResult({successYn: true }, true, "");
            }

        }
    }, [props.clickedConfirmYn]);


    function executeResult(result, closeYn, infoMessage) {
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }

    return (
        <View>
            {
                stepIndex === 0 ?
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("LOG_DETAIL_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("LOG_CREATE_DATE_TEXT")}
                            </Text>
                            <Text style={style.dateText}>
                                {props.args?.create_ts? parseLocaleDatetime(props.args?.create_ts) : ""}
                            </Text>
                        </View>

                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {'Levels'}
                            </Text>
                            {
                                props.args?.audit_log_severity_code === "ERR" ?
                                <View style={{flexDirection: "row", alignItems: "center"}}>
                                    <ErrorImg style={style.statusImg} />
                                </View>
                                : props.args?.audit_log_severity_code === "DENY" ?
                                <View style={{flexDirection: "row", alignItems: "center"}}>
                                    <AlertImg style={style.statusImg} />
                                </View>
                                :
                                <View style={{flexDirection: "row", alignItems: "center"}}>
                                    <StatusStableImg style={style.statusImg} />
                                </View>
                            }
                        </View>

                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {'Category'}
                            </Text>
                            <Text style={{...style.dateText,color: "#333"}}>
                                {props.args?.category ? props.args?.category : "System"}
                            </Text>
                        </View>


                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {'Sub Category'}
                            </Text>
                            <Text style={{...style.dateText,color: "#333"}}>
                                {props.args?.sub_category ? props.args?.sub_category : "System"}
                            </Text>
                        </View>

                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {'Source'}
                            </Text>
                            <Text style={{...style.dateText,color: "#333"}}>
                                {props.args?.source ? props?.args?.source : '-'}
                            </Text>
                        </View>






                        <View style={style.rowDivContainer}></View>
                        <View style={style.rowTopAlignContainer}>
                            <Text style={style.columnText}>
                                {t("LOG_MESSAGE_TEXT")}
                            </Text>
                            <TextArea
                                key={3}
                                width={570}
                                height={600}
                                value={props.args?.message || ""}
                                type={"text"}
                                activeYn={false}
                                inputCb={(v)=>{}}
                                warnYn={false}
                                placeHolderText={t("")}
                            />
                        </View>
                    </View>
                </View>
                :null
            }
        </View>
    );
}


const style = StyleSheet.create({
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",

    },
    mainContainer: {
        marginTop: 38
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },
    rowDescribeContainer: {
        marginLeft: 150, marginTop: -10, marginBottom: 40,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 12,
        color: "#8c8c8c"
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 58,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
    dateText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#9ea0a5"
    },
    statusImg: {
        marginRight: 3
    },
});


const labelStyle = {
    fontFamily: FONT.REGULAR,
    fontSize: 12,
    color: "#333"
}